export const localeMessage = {
  en: {
    draft: `Draft`,
    EditNow: `Edit Now`,
    viewMore: `View More`,
    viewLess: `View Less`,
    All: `All`,
    productSources: `Product Sources`,
    collectByAdd: `Collect & Add`,
    ceneratedFromChannelProduct: `Generated from Channel Product`,
    addManually: `Add Manually`,
    copyToChannel: `Copy to channel`,
    chooseDestinationStore: `Choose destination store`,
    productsCopiedTo: `products copied to`,
    selectStore: `Select Store`,
    cancel: `Cancel`,
    copyAsDraft: `Copy as draft`,
    result: `Result`,
    editAndPublishDec: `Edit and publish from the draft in the Store`,
    copySuccess: `Copy success\uFF01`,
    copyFailedResult: `Products failed to clone`,
    copyAsDraftTip: `products copied as draft`,
    close: `Close`,
    viewNow: `View Now`,
    lengthLimit: `Length Should be between 1-999,999`,
    widthLimit: `Width Should be between 1-999,999`,
    heightLimit: `Height Should be between 1-999,999`,
    noStoreTip: `There is no Store to copy the product to, Integrate Store now.`,
    addStore: `Add Store`,
    confirm: `Confirm`,
    maxTip: `Choose up to 10 stores at a time`,
    chooseStoreLimit: `Choose at least 1 destination store to copy product`
  },
  zh: {
    draft: `\u8349\u7A3F\u7BB1`,
    EditNow: `\u9A6C\u4E0A\u7F16\u8F91`,
    viewMore: `\u5C55\u5F00`,
    viewLess: `\u6536\u8D77`,
    All: `\u5168\u90E8`,
    productSources: `\u5546\u54C1\u6765\u6E90`,
    collectByAdd: `\u8BA4\u9886\u521B\u5EFA`,
    ceneratedFromChannelProduct: `\u636E\u6E20\u9053\u751F\u6210`,
    addManually: `\u624B\u52A8\u521B\u5EFA`,
    copyToChannel: `\u514B\u9686\u5230\u6E20\u9053`,
    chooseDestinationStore: `\u9009\u62E9\u76EE\u6807\u5E97\u94FA`,
    productsCopiedTo: `\u4E2A\u5546\u54C1\u514B\u9686\u5230`,
    selectStore: `\u9009\u62E9\u5E97\u94FA`,
    cancel: `\u53D6\u6D88`,
    copyAsDraft: `\u514B\u9686\u6210\u8349\u7A3F`,
    result: `\u7ED3\u679C`,
    editAndPublishDec: `\u5728\u5E97\u94FA\u7684\u5546\u54C1\u8349\u7A3F\u7BB1\u8FDB\u884C\u7F16\u8F91\u548C\u53D1\u5E03`,
    copySuccess: `\u514B\u9686\u6210\u529F\uFF01`,
    copyFailedResult: `\u4E2A\u5546\u54C1\u514B\u9686\u5931\u8D25`,
    copyAsDraftTip: `\u4E2A\u5546\u54C1\u514B\u9686\u6210\u8349\u7A3F`,
    close: `\u5173\u95ED`,
    viewNow: `\u9A6C\u4E0A\u67E5\u770B`,
    lengthLimit: `\u957F\u7684\u8F93\u5165\u8303\u56F4\u662F1-999,999`,
    widthLimit: `\u5BBD\u7684\u8F93\u5165\u8303\u56F4\u662F1-999,999`,
    heightLimit: `\u9AD8\u7684\u8F93\u5165\u8303\u56F4\u662F1-999,999`,
    noStoreTip: `\u6CA1\u6709\u53EF\u4EE5\u514B\u9686\u5230\u7684\u5E97\u94FA\uFF0C\u5FEB\u53BB\u7ED1\u5B9A\u65B0\u5E97\u94FA\u5427`,
    addStore: `\u65B0\u589E\u5E97\u94FA`,
    confirm: `\u786E\u5B9A`,
    maxTip: `\u6BCF\u6B21\u6700\u591A\u9009\u62E910\u4E2A\u5E97\u94FA`,
    chooseStoreLimit: `\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u5BB6\u76EE\u6807\u5E97\u94FA`
  },
  id: {
    draft: `Draft`,
    EditNow: `Edit Sekarang`,
    viewMore: `Lihat lebih banyak`,
    viewLess: `Lihat lebih sedikit`,
    All: `Semua`,
    productSources: `Sumber Produk`,
    collectByAdd: `Collect & Tambahkan`,
    ceneratedFromChannelProduct: `Generate dari Channel Produk`,
    addManually: `Tambahkan Manual`,
    copyToChannel: `Salin ke Channel`,
    chooseDestinationStore: `Pilih Toko tujuan salin produk`,
    productsCopiedTo: `Produk disalin ke`,
    selectStore: `Pilih Toko`,
    cancel: `Batal`,
    copyAsDraft: `Salin sebagai draf`,
    result: `Hasil`,
    editAndPublishDec: `Edit dan Tampilkan dari Draf di Toko`,
    copySuccess: `Berhasil disalin!`,
    copyFailedResult: `Produk gagal digandakan`,
    copyAsDraftTip: `Produk disalin sebagai Draf`,
    close: `Tutup`,
    viewNow: `Lihat sekarang`,
    lengthLimit: `Panjang Harus antara 1-99,999`,
    widthLimit: `Lebar Harus antara 1-99,999`,
    heightLimit: `Tinggi Harus antara 1-99,999`,
    noStoreTip: `Tidak ada Toko tujuan salin Produk, Integrasikan Toko sekarang.`,
    addStore: `Tambah Toko`,
    confirm: `Konfirmasi`,
    maxTip: `Pilih maks. 10 Toko sekali jalan`,
    chooseStoreLimit: `Pilih setidaknya 1 Toko tujuan untuk salin produk`
  },
  th: {
    draft: `\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07`,
    EditNow: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E17\u0E31\u0E19\u0E17\u0E35`,
    viewMore: `\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21`,
    viewLess: `\u0E22\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32`,
    All: `\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    productSources: `\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E17\u0E35\u0E48\u0E21\u0E32\u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    collectByAdd: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01&\u0E2A\u0E23\u0E49\u0E32\u0E07`,
    ceneratedFromChannelProduct: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E15\u0E32\u0E21\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    addManually: `\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E2D\u0E07`,
    copyToChannel: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    chooseDestinationStore: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22`,
    productsCopiedTo: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07`,
    selectStore: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    cancel: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01`,
    copyAsDraft: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07`,
    result: `\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C`,
    editAndPublishDec: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E17\u0E35\u0E48\u0E01\u0E25\u0E48\u0E2D\u0E07\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    copySuccess: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08!`,
    copyFailedResult: `\u0E1C\u0E25\u0E34\u0E15\u0E20\u0E31\u0E13\u0E11\u0E4C\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E42\u0E04\u0E25\u0E19`,
    copyAsDraftTip: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07`,
    close: `\u0E1B\u0E34\u0E14`,
    viewNow: `\u0E14\u0E39\u0E17\u0E31\u0E19\u0E17\u0E35`,
    lengthLimit: `\u0E08\u0E33\u0E01\u0E31\u0E14\u0E04\u0E27\u0E32\u0E21\u0E22\u0E32\u0E27\u0E04\u0E37\u0E2D1-999,999`,
    widthLimit: `\u0E08\u0E33\u0E01\u0E31\u0E14\u0E04\u0E27\u0E32\u0E21\u0E01\u0E27\u0E49\u0E32\u0E07\u0E04\u0E37\u0E2D1-999,999`,
    heightLimit: `\u0E08\u0E33\u0E01\u0E31\u0E14\u0E04\u0E27\u0E32\u0E21\u0E2A\u0E39\u0E07\u0E04\u0E37\u0E2D1-999,999`,
    noStoreTip: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E43\u0E2B\u0E49\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E15\u0E2D\u0E19\u0E19\u0E35\u0E49`,
    addStore: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    confirm: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19`,
    maxTip: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E44\u0E14\u0E49\u0E16\u0E36\u0E07 10 \u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E43\u0E19\u0E41\u0E15\u0E48\u0E25\u0E30\u0E04\u0E23\u0E31\u0E49\u0E07`,
    chooseStoreLimit: `\u0E42\u0E1B\u0E23\u0E14\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E49\u0E32\u0E2B\u0E21\u0E32\u0E22\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E49\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`
  },
  vn: {
    draft: `B\u1EA3n nh\xE1p`,
    EditNow: `Xem ngay`,
    viewMore: `Xem th\xEAm`,
    viewLess: `Thu g\u1ECDn`,
    All: `T\u1EA5t c\u1EA3`,
    productSources: `Ngu\u1ED3n s\u1EA3n ph\u1EA9m`,
    collectByAdd: `Nh\u1EADn & th\xEAm`,
    ceneratedFromChannelProduct: `T\u1EA1o theo K\xEAnh`,
    addManually: `Th\xEAm th\u1EE7 c\xF4ng`,
    copyToChannel: `Sao ch\xE9p \u0111\u1EBFn k\xEAnh`,
    chooseDestinationStore: `Ch\u1ECDn c\u1EEDa h\xE0ng \u0111\xEDch`,
    productsCopiedTo: `s\u1EA3n ph\u1EA9m sao ch\xE9p \u0111\u1EBFn`,
    selectStore: `Ch\u1ECDn c\u1EEDa h\xE0ng`,
    cancel: `H\u1EE7y`,
    copyAsDraft: `Sao ch\xE9p th\xE0nh b\u1EA3n nh\xE1p`,
    result: `K\u1EBFt qu\u1EA3`,
    editAndPublishDec: `Ch\u1EC9nh s\u1EEDa v\xE0 \u0111\u0103ng t\u1EEB b\u1EA3n nh\xE1p v\xE0o c\u1EEDa h\xE0ng`,
    copySuccess: `Sao ch\xE9p th\xE0nh c\xF4ng!`,
    copyFailedResult: `S\u1EA3n ph\u1EA9m kh\xF4ng sao ch\xE9p \u0111\u01B0\u1EE3c`,
    copyAsDraftTip: `s\u1EA3n ph\u1EA9m sao ch\xE9p th\xE0nh b\u1EA3n nh\xE1p`,
    close: `\u0110\xF3ng`,
    viewNow: `Xem ngay`,
    lengthLimit: `Ph\u1EA1m vi nh\u1EADp c\u1EE7a Chi\u1EC1u d\xE0i t\u1EEB 1-999.999`,
    widthLimit: `Ph\u1EA1m vi nh\u1EADp c\u1EE7a Chi\u1EC1u r\u1ED9ng t\u1EEB 1-999.999`,
    heightLimit: `Ph\u1EA1m vi nh\u1EADp c\u1EE7a Chi\u1EC1u cao t\u1EEB 1-999.999`,
    noStoreTip: `Kh\xF4ng c\xF3 c\u1EEDa h\xE0ng n\xE0o c\xF3 th\u1EC3 sao ch\xE9p. Nhanh ch\xF3ng \u1EE7y quy\u1EC1n c\u1EEDa h\xE0ng m\u1EDBi n\xE0o`,
    addStore: `Th\xEAm c\u1EEDa h\xE0ng`,
    confirm: `X\xE1c nh\u1EADn`,
    maxTip: `M\u1ED7i l\u1EA7n ch\u1ECDn l\xEAn \u0111\u1EBFn 10 c\u1EEDa h\xE0ng`,
    chooseStoreLimit: `Ch\u1ECDn \xEDt nh\u1EA5t 1 c\u1EEDa h\xE0ng \u0111\xEDch \u0111\u1EC3 sao ch\xE9p s\u1EA3n ph\u1EA9m`
  }
};
